import { useTranslate } from "@refinedev/core";
import { Flex, Typography, Button } from "antd";
import { CaretLeftIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useAntTheme } from "hooks/useAntTheme";

export const ProjectHeaderNew = () => {
  const t = useTranslate();
  const navigate = useNavigate();
  const { theme } = useAntTheme();

  const handleBack = () => {
    navigate("/media/projects");
  };

  return (
    <Flex vertical style={{ marginTop: -24 }}>
      <Typography.Title level={2} data-testid="ProjectTitle">
        {t("media.projects.detail.title")}
      </Typography.Title>
      <Typography.Text
        type="secondary"
        style={{ marginTop: "-16px", fontWeight: "normal" }}
      >
        {t("media.projects.detail.subtitle")}
      </Typography.Text>
      <Button
        type="text"
        icon={<CaretLeftIcon />}
        onClick={handleBack}
        style={{
          marginTop: 15,
          paddingLeft: 0,
          alignSelf: "flex-start",
          color: theme.colorTextBaseRedesign,
          fontSize: 18,
          fontWeight: 400,
        }}
      >
        {t("media.projects.detail.backToProject")}
      </Button>
    </Flex>
  );
};
